import { createSlice } from "@reduxjs/toolkit";
import { setToken } from "../Utilities/apiUtil";
import appConst from '../Utilities/appConst.json';

const loginSlice = createSlice({
    name: 'login',
    initialState: { token: "" },
    reducers: {
        setToken: (state, action) => {
            if (action.payload) {
                const d = new Date();
                try {
                    sessionStorage.setItem(appConst.TOKEN, action.payload);
                    sessionStorage.setItem(`dateStart`, d.getTime());
                }
                catch (err) {
                    console.log(err);
                }

                state.token = action.payload;
                setToken(action.payload)
            }
        }
    }
});

export const loginActions = loginSlice.actions;
export default loginSlice;